(() => {
  class FaqHub extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('[data-faq-input]');
      this.clear = this.querySelector('[data-faq-clear]');
      this.status = this.querySelector('[data-faq-status]');
      this.groups = [...this.querySelectorAll('[data-faq-group]')];
      this.items = [...this.querySelectorAll('[data-faq-item]')].map(node => ({
        node,
        text: this.normalize([...node.querySelectorAll('summary, [data-faq-copy]')].map(part => part.textContent).join(' '))
      }));
      if (!this.input || !this.items.length) return;
      this.querySelector('[data-faq-search]').hidden = false;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.filter(), 120);
      }, options);
      this.clear.addEventListener('click', () => this.reset(true), options);
      this.querySelector('[data-faq-reset]').addEventListener('click', () => this.reset(true), options);
      this.addEventListener('click', event => {
        const topic = event.target.closest('[data-faq-topic]');
        if (!topic || !this.contains(topic)) return;
        this.reset(false);
        this.selectTopic(topic.hash);
      }, options);
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          event.stopPropagation();
          this.reset(true);
        }
      }, options);
      window.addEventListener('hashchange', () => this.revealHash(), options);
      this.revealHash();
      this.filter();
    }

    normalize(text) {
      return text.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase(document.documentElement.lang || 'en').trim();
    }

    filter() {
      const terms = this.normalize(this.input.value).split(/\s+/).filter(Boolean);
      let count = 0;
      this.items.forEach(({ node, text }) => {
        node.hidden = !terms.every(term => text.includes(term));
        if (!node.hidden) count++;
      });
      this.groups.forEach(group => { group.hidden = !group.querySelector('[data-faq-item]:not([hidden])'); });
      this.clear.hidden = !this.input.value;
      this.querySelector('[data-faq-empty]').hidden = count > 0;
      this.status.textContent = terms.length ? (count === 1 ? this.dataset.resultOne : this.dataset.resultMany).replace('[count]', count) : '';
      if (terms.length) this.selectTopic('');
    }

    reset(focus) {
      clearTimeout(this.timer);
      this.input.value = '';
      this.filter();
      if (focus) this.input.focus();
    }

    selectTopic(hash) {
      this.querySelectorAll('[data-faq-topic]').forEach(link => {
        if (link.hash === hash) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    revealHash() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (!target || !this.contains(target)) return;
      this.reset(false);
      if (target.matches('[data-faq-item]')) target.open = true;
      const group = target.closest('[data-faq-group]');
      if (group) this.selectTopic('#' + group.id);
      requestAnimationFrame(() => {
        if (this.isConnected) target.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  }
  if (!customElements.get('faq-hub')) customElements.define('faq-hub', FaqHub);
})();
